// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6e3b5929","228":"53001cb0","433":"92fb48c6","605":"28f45c59","606":"a27d50bc","830":"2256fce0"}[chunkId] + ".chunk.js";
};